// The Power subscription is the member's single non-club subscription — matches the billing-page
// predicate `subscriptions.find(sub => !sub.clubId)`.
export const selectPowerSubscriptionId = (subscriptions) => (
    subscriptions?.find((sub) => !sub.clubId)?.id ?? null
);

export default selectPowerSubscriptionId;
